import { Component, OnInit, EventEmitter, Input, ViewChild, Output, TemplateRef, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { SharedService } from '../../../shared-components/shared.service';
import { MealService, MealServiceFilter } from '../meal-service.model';

@AutoUnsubscribe()
@Component({
    selector: 'app-meal-service-filter',
    templateUrl: './meal-service-filter.component.html',
    styles: []
})
export class MealServiceFilterComponent implements OnInit, OnDestroy {

    @Input() filterData: MealService;
    @Input() showFilter: EventEmitter<any>;
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input('clearFilter') clearFilterEvent: EventEmitter<any>;
    @Output() filterChange = new EventEmitter<any>();
    @Output() closeFilterEvent = new EventEmitter();
    @ViewChild('menuTemplate') menuTemplate: TemplateRef<any>;
    previousFilterData = new MealServiceFilter();
    clearFilterSubscription: Subscription;

    constructor(
        private sharedService: SharedService
    ) { }

    ngOnInit() {
        this.clearFilterSubscription = this.clearFilterEvent.subscribe(() => {
            const keys = Object.keys(this.filterData);
            for (let i = 0; i < keys.length; i++) {
                const key = keys[i];
                this.filterData[key] = undefined;
            }
            this.previousFilterData = JSON.parse(JSON.stringify(this.filterData));
            this.previousFilterData.FromDate = null;
            this.previousFilterData.ToDate = null;
            this.filterChange.emit();
        });
        Object.assign(this.previousFilterData, this.filterData);
    }

    ngOnDestroy() {

    }

    // Methods
    clearFilter() {
        this.filterData['FromDate'] = null;
        this.filterData['ToDate'] = null;
        this.filterChange.emit();
    }

    closeFilter() {
        this.closeFilterEvent.emit();
    }
}
